import { Link, useLocation } from 'react-router-dom';
import { Headphones, Ticket } from 'lucide-react';
import { cn } from '../../lib/utils';

const navItems = [
    { href: '/my-guides', icon: Headphones, label: 'My Guides' },
    { href: '/redeem', icon: Ticket, label: 'Redeem' },
];

export function TravelerBottomNav() {
    const location = useLocation();

    if (location.pathname.startsWith('/guide/')) return null;

    return (
        <nav
            className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-[#121620]/95 backdrop-blur-xl border-t border-white/10"
            style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
            data-testid="traveler-bottom-nav"
        >
            <div className="flex items-center justify-around h-16">
                {navItems.map((item) => {
                    const isActive = location.pathname === item.href;
                    return (
                        <Link
                            key={item.href}
                            to={item.href}
                            className={cn(
                                'flex flex-col items-center justify-center gap-1 w-full h-full transition-colors active:scale-95',
                                isActive ? 'text-gold' : 'text-white/40'
                            )}
                            data-testid={`bottom-nav-${item.label.toLowerCase().replace(/\s/g, '-')}`}
                        >
                            <item.icon className={cn('w-5 h-5', isActive && 'drop-shadow-[0_0_6px_rgb(212,175,55)]')} />
                            <span className="text-[10px] font-medium tracking-wide">{item.label}</span>
                        </Link>
                    );
                })}
            </div>
        </nav>
    );
}
